<div>
    <app-audi-text variant="order4" className="audi-type-normal" weight="bold" text="Vehicle Details"></app-audi-text>
    <br /><br />
    <div class="column__list">
        <div class="card__list">
            <app-audi-text-input inputId="view-quote-vehicleModel" label="Vehicle Model" value="{{selectedVehicleDetail?.modelName}}" isRequired="true" disabled=true>
            </app-audi-text-input>
        </div>
        <div class="card__list">
            <app-audi-text-input inputId="view-quote-modelYear" label="Model Year" value="{{selectedVehicleDetail?.year}}" isRequired="true" disabled=true>
            </app-audi-text-input>
        </div>
        <div class="card__list">
            <app-audi-text-input inputId="view-quote-odometer" label="Odometer Reading" value="{{selectedVehicleDetail?.currentOdometer}}" isRequired="true" disabled=true>
            </app-audi-text-input>
        </div>
        <div class="card__list">
            <app-audi-text-input inputId="view-quote-modelCode" label="Model Code" value="{{selectedVehicleDetail?.modelNumber}}" isRequired="true" disabled=true>
            </app-audi-text-input>
        </div>
        <div class="card__list">
            <app-audi-text-input inputId="view-quote-modelDescription" label="Model Description" value="{{selectedVehicleDetail?.modelDescription}}" isRequired="true"
                disabled=true>
            </app-audi-text-input>
        </div>
        <div class="card__list">
            <app-audi-text-input inputId="view-quote-deliveryDate" label="Delivery Date" value="{{selectedVehicleDetail?.deliveryDate | date:'dd MMMM yyyy'}}" isRequired="true"
                disabled=true>
            </app-audi-text-input>
        </div>
        <div class="card__list">
            <app-audi-text-input inputId="view-quote-vin" label="VIN Number" value="{{selectedVehicleDetail?.vin}}" isRequired="true" disabled=true>
            </app-audi-text-input>
        </div>
        <div class="card__list">
            <app-audi-text-input inputId="view-quote-engineNumber" label="Engine Number" value="{{selectedVehicleDetail?.engineNumber}}" isRequired="true" disabled=true>
            </app-audi-text-input>
        </div>
    </div>
    <br />
    <app-audi-text variant="order4" className="audi-type-normal" weight="bold" text="Current Plan Details"></app-audi-text>
    <br /><br />
    <div class="column__list">
        <div class="card__list">
            <app-audi-text-input inputId="view-quote-planType" label="Plan Type" value="{{selectedVehicleDetail?.planType}}" isRequired="true" disabled=true>
            </app-audi-text-input>
        </div>
        <div class="card__list">
            <app-audi-text-input inputId="view-quote-planStartDate" label="Plan Start Date" value="{{selectedVehicleDetail?.planStart  | date:'dd MMMM yyyy'}}" isRequired="true"
                disabled=true>
            </app-audi-text-input>
        </div>
        <div class="card__list">
            <app-audi-text-input inputId="view-quote-planEndDate" label="Plan End Date" value="{{selectedVehicleDetail?.planEnd | date:'dd MMMM yyyy'}}" isRequired="true"
                disabled=true>
            </app-audi-text-input>
        </div>
        <div class="card__list">
            <app-audi-text-input inputId="view-quote-planStartKM" label="Plan Start KMs" value="{{selectedVehicleDetail?.startKM}}" isRequired="true" disabled=true>
            </app-audi-text-input>
        </div>
        <div class="card__list">
            <app-audi-text-input inputId="view-quote-planEndKM" label="Plan End KMs" value="{{selectedVehicleDetail?.currentPlanEndKM}}" isRequired="true" disabled=true>
            </app-audi-text-input>
        </div>
        <div class="card__list">
            <app-audi-text-input inputId="view-quote-warrantyStatus" label="Warranty" value="{{selectedVehicleDetail?.warrantyStatus}}" isRequired="true" disabled="true">
            </app-audi-text-input>
        </div>
    </div>
    <br />
    <app-audi-text variant="order4" className="audi-type-normal" weight="bold" text="New Plan Details"></app-audi-text>
    <br /><br />
    <div class="column__list">
        <div class="card__list">
            <app-audi-text-input inputId="view-quote-newPlanType" label="Plan Type" value="{{newPlanOption?.planType}}" isRequired="true" disabled=true>
            </app-audi-text-input>
        </div>
        <div class="card__list">
            <app-audi-text-input inputId="view-quote-newPlanStartDate" label="Plan Start Date" value="{{newPlanOption?.planStartDate | date:'dd MMMM yyyy'}}" isRequired="true"
                disabled=true>
            </app-audi-text-input>
        </div>
        <div class="card__list">
            <app-audi-text-input inputId="view-quote-newPlanEndDate" label="Plan End Date" value="{{newPlanOption?.planEndDate | date:'dd MMMM yyyy'}}" isRequired="true"
                disabled=true>
            </app-audi-text-input>
        </div>
        <div class="card__list">
            <app-audi-text-input inputId="view-quote-newPlanStartKM" label="Plan Start KMs" value="{{newPlanOption?.planStartKM}}" isRequired="true" disabled=true>
            </app-audi-text-input>
        </div>
        <div class="card__list">
            <app-audi-text-input inputId="view-quote-newPlanEndKM" label="Plan End KMs" value="{{newPlanOption?.maxKilometers}}" isRequired="true" disabled=true>
            </app-audi-text-input>
        </div>
    </div>
    <br />
    <app-audi-text variant="order4" className="audi-type-normal" weight="bold" text="Pricing Details"></app-audi-text>
    <br /><br />
    <div class="column__list">
        <div class="card__list">
            <app-audi-text-input inputId="view-quote-newPlanPrice" label="Total (incl. VAT)" value="R{{newPlanOption?.price | number}}" isRequired="true" disabled=true>
            </app-audi-text-input>
        </div>
        <div class="card__list"></div>
        <div class="card__list"></div>
    </div>
    <br />
    <app-audi-text variant="order4" className="audi-type-normal" weight="bold" text="Owner Details">
    </app-audi-text><br />
    <app-audi-text variant="copy2" text="(Please update if necessary)"></app-audi-text>
    <br /><br />
    <form [formGroup]="viewQuoteOwnerInfoForm">
        <div class="column__list">
            <div class="card__list">
                <app-audi-text-input inputId="view-quote-firstName" label="First Name*" formControlName="firstName" isRequired="true" (onblur)="onValidateInput('firstName',null)"
                    (valueChange)="onValidateInput('firstName',$event)" validationMessage="{{firstNameValidationMessage}}">
                </app-audi-text-input>
            </div>
            <div class="card__list">
                <app-audi-text-input inputId="view-quote-lastName" label="Last Name*" formControlName="lastName" isRequired="true" (onblur)="onValidateInput('lastName',null)"
                    (valueChange)="onValidateInput('lastName',$event)" validationMessage="{{lastNameValidationMessage}}">
                </app-audi-text-input>
            </div>
            <div class="card__list">
                <app-audi-text-input inputId="view-quote-mobileNumber" label="Mobile Number" formControlName="mobileNumber" isRequired="true"
                    (onblur)="onValidateInput('mobileNumber',null)" (valueChange)="onValidateInput('mobileNumber',$event)" validationMessage="{{mobileNumberValidationMessage}}">
                </app-audi-text-input>
            </div>
            <div class="card__list">
                <app-audi-text-input inputId="view-quote-email" label="Email Address*" formControlName="emailAddress" isRequired="true"
                    (onblur)="onValidateInput('emailAddress',null)" (valueChange)="onValidateInput('emailAddress',$event)" validationMessage="{{emailAddressValidationMessage}}">
                </app-audi-text-input>
            </div>
        </div>
    </form>

    <br />
    <div class="column__list">
        <div class="card__list">
            <app-audi-checkbox inputId="view-quote-accept-conditions" label="I accept the terms and conditions and would like to buy now*" [(checked)]="acceptConditions">
            </app-audi-checkbox>
        </div>
        <div class="card__list">
            <app-audi-button text="View Terms and Conditions" (click)="onViewTermsAndConditions()" variant="secondary">
            </app-audi-button>
        </div>
    </div>

    <div>
        <app-audi-text variant="copy2" text="* Indicates required fields"></app-audi-text>
        <br /><br />
        <div style="display: flex;">
            <app-audi-button text="Buy Now" (click)="onBuyNow()" [disabled]="!acceptConditions || !viewQuoteOwnerInfoForm.valid">
            </app-audi-button>
            <!-- <app-audi-button text="Buy Now" (click)="onBuyNow()" [disabled]="!acceptConditions || !viewQuoteOwnerInfoForm.valid || !isPendingContractActivation">
            </app-audi-button> -->
            <!-- <app-audi-text variant="copy2" *ngIf="!this.isPendingContractActivation" style ="padding: 10px;" text="There is a pending contract activation on this vehicle, please allow for upto 24 hours for it to reflect on the system. If you still have any questions or need help with anything, please contact our Customer Care Centre."></app-audi-text><br /> -->
        </div>
    </div>

    <br />
    <div>
        <app-audi-button text="Download Quote" (click)="onDownloadQuote()">
        </app-audi-button>
    </div>

    <br />
    <app-audi-button text="Back" (click)="onBackToCustomizePlan()" variant="secondary"></app-audi-button>

    <!--modal for confirming redirect-->
    <p-dialog header="Payment Redirect" [(visible)]="displayRedirectNotice" [baseZIndex]="10000" [draggable]="false" [resizable]="false">
        <p>
            You will be redirected to PayU to make your payment. Please confirm if you want to proceed.
        </p>
        <ng-template pTemplate="footer">
            <app-audi-button (click)="displayRedirectNotice=false" text="No"></app-audi-button>
            <app-audi-button (click)="onProceedToPayment()" text="Yes"></app-audi-button>
        </ng-template>
    </p-dialog>
</div>